import { takeLatest, put, call, fork } from "redux-saga/effects";
import { RegionService } from "services";

import {
    fetchRegionList,
    fetchedRegionList,
    failedFetchRegionList,
    fetchedRegionWiseList,
    failedFetchRegionWiseList,
    createdRegion,
    failedCreateRegion
} from "./../actions";

import { REGION_DISTRIBUTOR_ACTIONS } from "constants/actions";


function* fetchRegionListHandler({ payload }) {
    const { data, error } = yield call(RegionService.getRegionList, payload.id);
    if (!error) {
        yield put(fetchedRegionList(payload.id, data.results));
    } else {
        yield put(failedFetchRegionList(payload.id, error));
    }
}

function* fetchRegionWiseList({ payload }) {
    const { data, error } = yield call(RegionService.getCaseListInRegion, payload.id);
    if (!error) {
        yield put(fetchedRegionWiseList(payload.id, data.results));
    } else {
        yield put(failedFetchRegionWiseList(payload.id, error));
    }
}

function* createRegion({ payload }) {
    const { data, error } = yield call(RegionService.createRegion, payload.companyId, payload.data);
    if (!error) {
        yield put(createdRegion(payload.companyId, data.results));
        yield put(fetchRegionList(payload.companyId));
    } else {
        yield put(failedCreateRegion(payload.companyId, error));
    }
}

export default fork(function*() {
    yield takeLatest(
        REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_DATA,
        fetchRegionListHandler
    );

    yield takeLatest(
        REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_WISE_DATA,
        fetchRegionWiseList
    );

    yield takeLatest(
        REGION_DISTRIBUTOR_ACTIONS.CREATE_REGION,
        createRegion
    );
});